// @ts-strict-ignore
import React from 'react'
import Link from 'components/Link'
import { Button, Grid, Typography } from '@mui/material'
import { graphql } from 'relay-runtime'
import {
  Page,
  PageBody,
  PageContent,
  PageHeader,
  PageHeaderBreadcrumbs,
  PageHeaderDescription,
  PageHeaderTitle,
} from 'components/Layouts/V3'
import { useFragment } from 'react-relay'
import { BlogSubcategorySignedIn_Query$key } from '__generated__/BlogSubcategorySignedIn_Query.graphql'
import PagePlaceholder from 'components/PagePlaceholder'
import BlogPostItem from '../BlogPostItem'

export interface IBlogSubcategorySignedInProps {
  queryFragmentRef: BlogSubcategorySignedIn_Query$key
}

function BlogSubcategorySignedIn(props: IBlogSubcategorySignedInProps) {
  const { queryFragmentRef } = props

  const data = useFragment(
    graphql`
      fragment BlogSubcategorySignedIn_Query on Query
      @argumentDefinitions(
        subcategory: { type: "String!" }
      )
      {
        blogPosts(last: 20, subcategorySlug: $subcategory) {
          nodes {
            id
            ...BlogPostItem_BlogPost
          }
        }
        blogSubcategory(slug: $subcategory) {
          name
          slug
          description
          heroImageUrl
          blogCategory {
            name
            slug
          }
        }
      }
    `,
    queryFragmentRef,
  )

  const blogSubcategory = data?.blogSubcategory
  const blogPosts = data?.blogPosts
  const blogCategory = blogSubcategory?.blogCategory

  if (!blogSubcategory) {
    return (
      <PagePlaceholder title="Not Found" />
    )
  }

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>
          {blogSubcategory?.blogCategory?.name} / {blogSubcategory?.name}
          <Link href="/blog/new" style={{ textDecoration: 'none', marginLeft: 6 }}>
            <Button color="primary">
              Create New Post
            </Button>
          </Link>
        </PageHeaderTitle>

        <PageHeaderDescription>
          {blogSubcategory.description}
        </PageHeaderDescription>

        <PageHeaderBreadcrumbs
          breadcrumbs={[
            {
              name: 'Blog',
              href: '/blog',
            },
            {
              name: blogCategory.name,
              href: `/blog/category/${blogCategory.slug}`,
            },
            {
              name: blogSubcategory.name,
              href: `/blog/category/${blogCategory.slug}/${blogSubcategory.slug}`,
            },
          ]}
        />
      </PageHeader>

      {blogSubcategory.heroImageUrl &&
        <img alt={blogSubcategory.name ?? 'image-of-subcategory'} src={blogSubcategory.heroImageUrl} width="100%" />}

      <PageBody>
        <PageContent>
          <Grid container spacing={3}>
            {blogPosts.nodes.length === 0 && (
              <Grid item xs={12} md={12} lg={12}>
                <Typography variant="h2">
                  No posts to show
                </Typography>
              </Grid>
            )}

            {blogPosts.nodes.map(blogPost => (
              <Grid key={blogPost.id} item xs={12} md={4} lg={4}>
                <BlogPostItem blogPostFragmentRef={blogPost} variant="outlined" />
              </Grid>
            ))}
          </Grid>
        </PageContent>
      </PageBody>
    </Page>
  )
}

export default React.memo(BlogSubcategorySignedIn)
